import React from 'react';
import { ImageWidget, VideoUrlWidget } from './widgets';
import SortableField from './SortableField';
import schemas from './schemas/contentEditor';

const graphqlUrl = process.env.REACT_APP_GRAPHQL_URL;

const resources = Object.keys(schemas).map(key => schemas[key]);

// NOTE: columnNames is a computed property
const ContentEditorGqlCmsConfig = {
  brand: 'EncourageX CMS',
  title: 'EncourageX CMS',
  mainTitle: 'EncourageX CMS - Editor Dashboard View',
  graphqlUrl,
  jsonSchemaFormExtensions: {
    widgets: {
      imageWidget: ImageWidget,
      videoUrlWidget: VideoUrlWidget,
    },
    fields: {
      sortableField: SortableField,
    },
  },
  readManySchema: {
    cellFormatter(value) {
      if (value && typeof value === 'object') {
        return <pre>{JSON.stringify(value)}</pre>;
      }
      return value;
    },
    sortStrategy: {
      type: 'SINGLE',
      defaultSortField: 'title',
    },
    searchStrategy: {
      type: 'FULLTEXT',
    },
    paginationStrategy: {
      type: 'STATIC',
    },
  },
  resources,
};

export default ContentEditorGqlCmsConfig;



// WEBPACK FOOTER //
// ./src/ContentEditorGqlCmsConfig.js